<template>
  <div id="help-wrapper">


    <div class="header-content">
      <h1>We can help. Tell us how.</h1>
    </div>

    <div class="uk-container uk-section">
      <form-container
              form_title="Fill out the form below to send our team a message."
              :fieldList="formFields"
              :resetSignal="resetSignal"
              success_message="Your feedback has been submitted."
              @output="processSubmit" @input="processInput"
      ></form-container>
    </div>
  </div>
</template>

<script>

	import formContainer from './formContainer'
	import api from '../../store/apicall.js'

	export default {
		name: "help",
		components: {
			formContainer
		}, data: function () {
			return {
				formFields: [
					['first_name'],
					['last_name'],
					['email'],
					['explanation']
				]
			}
		}, methods: {
			processSubmit: function (input) {
				api.post('/onboarding/feedback/', input).then(function (response) {
					console.log(response)
				}).catch(function (error) {
					console.log(error)
				})
			},
			processInput: function (input) {
				// console.log(input)
			}
		}
	}
</script>

<style scoped>

</style>
